import { MatchmakingMatchTypes } from '@colonist/game-base-types';
export const rankedMatchmakingMatchTypes = new Set([
    MatchmakingMatchTypes.RankedCitiesAndKnights4P,
    MatchmakingMatchTypes.RankedClassic4P,
    MatchmakingMatchTypes.RankedClassic1v1,
    MatchmakingMatchTypes.RankedRush4P
]);
export const citiesAndKnightsMatchmakingMatchTypes = new Set([
    MatchmakingMatchTypes.RankedCitiesAndKnights4P
]);
export const activeMatchmakingMatchTypes = new Set([
    MatchmakingMatchTypes.UnrankedClassic4P,
    MatchmakingMatchTypes.RankedClassic4P,
    MatchmakingMatchTypes.UnrankedClassic1v1,
    MatchmakingMatchTypes.RankedClassic1v1,
    MatchmakingMatchTypes.RankedCitiesAndKnights4P,
    MatchmakingMatchTypes.UnrankedShuffle,
    MatchmakingMatchTypes.RankedRush4P
]);
